module.exports = __webpack_public_path__ + "media/images/nrf/NRF_1980x400_1-26a215cd420e474b6dbaa36c2729ed09.jpg";